import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import cy from './cy.json';

export const languages = [
  { key: 'en', name: 'English' },
  { key: 'cy', name: 'Cymraeg' },
];

i18n.use(initReactI18next).init({
  resources: {
    cy: { translation: cy }, en: { translation: en },
  },
  lng: 'en',
  keySeparator: false,
  fallbackLng: {
    default: ['en'],
  },
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
